
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"45","viewBox":"18 15 45 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M48 20H20v28h28V20z","fill":"#fff"}}),_c('mask',{attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"20","y":"20","width":"20","height":"21"}},[_c('path',{attrs:{"d":"M24.356 26.632V20h10.888v6.632H39.6V41H20V26.632h4.356zm2.177 0h6.534V22.21h-6.534v4.422zm-4.355 2.21v9.947h15.244v-9.947H22.178zm7.622 2.21c.601 0 1.089.488 1.089 1.09v3.348a1.089 1.089 0 01-2.178 0v-3.349c0-.6.488-1.088 1.089-1.088z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#a)","fill":"#241F21"}},[_c('path',{attrs:{"d":"M24.356 26.632V20h10.888v6.632H39.6V41H20V26.632h4.356zm2.177 0h6.534V22.21h-6.534v4.422zm-4.355 2.21v9.947h15.244v-9.947H22.178zm7.622 2.21c.601 0 1.089.488 1.089 1.09v3.348a1.089 1.089 0 01-2.178 0v-3.349c0-.6.488-1.088 1.089-1.088z"}}),_c('path',{attrs:{"d":"M42.14 18.895H18.912v23.23h23.23v-23.23z"}})]),_c('path',{attrs:{"d":"M39.6 46.6a7 7 0 100-14 7 7 0 000 14z","fill":"#fff","stroke":"#fff","stroke-width":"3"}}),_c('path',{attrs:{"d":"M37.85 44.551a5.243 5.243 0 001.75.3c.614 0 1.203-.106 1.75-.3v-.576a1.75 1.75 0 10-3.5 0v.576zm-1.723-1.014a3.5 3.5 0 016.946 0 5.25 5.25 0 10-6.946 0zM39.6 46.6a7 7 0 110-14 7 7 0 010 14zm0-7a1.75 1.75 0 110-3.5 1.75 1.75 0 010 3.5z","fill":"#8BAADA"}})])])
          )
        }
      }
    